import React, { useEffect } from "react";
import { OutOfStockCard, Popover } from "@aph/ui-lib-humanx";

import serverCartErrorMessageSelector from "@/redux/slice/cart/selectors/serverCartErrorMessage";
import { DeviceInfo } from "@/interface/deviceInfo";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { setServerCartErrorMessage } from "@/redux/slice/cart/slice";
import { NEXT_PUBLIC_CDN_URL } from "@/libs/constants/auth";
import manageCart from "@/redux/slice/cart/container/manageCart";
import styles from "./CartManager.module.scss";

interface CartManagerProps {
  ua?: DeviceInfo;
}

const CartManager: React.FC<CartManagerProps> = (props) => {
  const { ua } = props;
  const dispatch = useAppDispatch();

  const serverCartErrorMessage = useAppSelector(serverCartErrorMessageSelector);

  manageCart({ dispatch });

  useEffect(() => {
    if (serverCartErrorMessage) {
      setTimeout(() => {
        dispatch(setServerCartErrorMessage(""));
      }, 10000);
    }
  }, [serverCartErrorMessage]);

  const isCartPopoverOpen = !!serverCartErrorMessage.length;

  return (
    <>
      {isCartPopoverOpen && (
        <Popover
          className={ua?.isDesktop ? styles.outOfStockPopover : ""}
          open={!!serverCartErrorMessage.length}
          label="Cart popover"
          placement={ua?.isDesktop ? "bottomRight" : "bottom"}
        >
          <OutOfStockCard
            leadingImage={`${NEXT_PUBLIC_CDN_URL}/images/ui_revamp_oos.svg`}
            title="Dear Customer!"
            subTitle={serverCartErrorMessage}
            ctaText="Ok, Got It"
            ctaButtonColor="secondaryPharma"
            ctaClick={() => dispatch(setServerCartErrorMessage(""))}
            onClick={() => dispatch(setServerCartErrorMessage(""))}
          />
        </Popover>
      )}
    </>
  );
};

export default CartManager;
